import Icon from 'lib/components/Icon/Icon'
import Logo from 'lib/components/Logo/Logo'
import { subBrands } from 'lib/settings/brands/sub-brands'
import React from 'react'

interface BrandHeaderProps {
  brand: string
  onGoBack?: () => void
  canGoBack: boolean
}

const BrandHeader: React.FC<BrandHeaderProps> = ({
  brand,
  onGoBack,
  canGoBack,
}) => {
  const subBrand = subBrands[brand]

  return (
    <div className="flex items-center justify-between mb-6">
      {canGoBack ? (
        <button type="button" onClick={onGoBack} className="flex-shrink-0">
          <Icon icon="arrow-left" className="w-6 h-6" />
        </button>
      ) : null}

      <div className="flex-grow text-center">
        <Logo
          brand={subBrand.logo.textOnlyDark}
          width="160"
          height="32"
          className="mx-auto"
        />
      </div>

      {/* Placeholder to balance spacing */}
      <div className="w-6 h-6" />
    </div>
  )
}

export default BrandHeader
